import Box from '@mui/material/Box'

const Drag = () => (
  <Box
    component='svg'
    height='16.055'
    viewBox='0 0 15.817 16.055'
    width='15.817'
    xmlns='http://www.w3.org/2000/svg'
    sx={(theme) => ({
      verticalAlign: 'baseline',
      '& .drag-fill': { fill: '#888' },
      '& .drag-outline': { fill: 'none', stroke: '#888' },
      '&:hover .drag-fill': { fill: theme.palette.primary.accent },
      '&:hover .drag-outline': { stroke: theme.palette.primary.accent }
    })}
  >
    <g id='Group_868' transform='translate(18635.019 -3458.35)'>
      <rect className='drag-fill' id='Rectangle_2225' width='1.536' height='12.037' transform='translate(-18627.846 3460.245)' />
      <rect className='drag-fill' id='Rectangle_2226' width='11.318' height='1.536' transform='translate(-18632.738 3465.495)' />
      <path className='drag-outline' id='Path_1260' d='M14.458,4.676l2.61-2.339,2.548,2.339' transform='translate(-18644.115 3457.363)' strokeWidth='2' />
      <path className='drag-outline' id='Path_1261' d='M30.724,13.832l2.339,2.783-2.339,2.717' transform='translate(-18653.578 3449.444)' strokeWidth='2' />
      <path className='drag-outline' id='Path_1262' d='M19.615,31.325l-2.61,2.339-2.548-2.339' transform='translate(-18644.115 3439.391)' strokeWidth='2' />
      <path className='drag-outline' id='Path_1263' d='M4.676,19.51l-2.339-2.5,2.339-2.438' transform='translate(-18635.979 3449.265)' strokeWidth='2' />
    </g>
  </Box>
)

export default Drag
